import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutation } from '@apollo/client/react';

import { toast } from '@anyx/shared-ui';
import { reportAppError } from '@anyx/shared-utils';

import { SAVE_CUSTOMER_TAGS } from '../graphql';

export function useSaveCustomerTags({ customerId }: { customerId?: string }) {
  const [mutate] = useMutation(SAVE_CUSTOMER_TAGS);
  const { t } = useTranslation('anychat');

  const saveCustomerTags = useCallback(
    async (customerTagNames: string[] = []): Promise<boolean> => {
      if (!customerId) {
        return false;
      }

      try {
        const { data } = await mutate({
          variables: {
            input: {
              customerId,
              customerTagNames,
            },
          },
          refetchQueries: ['GetCustomerTags', 'ChatList', 'ChatAsideHeader'],
        });

        if (!data?.SetChatCustomerTags) throw new Error('Failed to save customer tags');

        return true;
      } catch (error) {
        toast.error(t('anychat.customer.customerTagPopover.error'));
        reportAppError(error);
        return false;
      }
    },
    [customerId, mutate, t]
  );

  return {
    saveCustomerTags,
  };
}
